module.exports = __webpack_public_path__ + "static/img/2.d91d4e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nationalDay/card/2.png
// module id = 93KF
// module chunks = 2